module.exports = __webpack_public_path__ + "media/images/growth-icon-45272541b1ac208112eb47c26310321a.png";